import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import { addDoc, setDoc, doc, collection, serverTimestamp } from "firebase/firestore";
import {auth, db} from "../../firebase" 
import { createUserWithEmailAndPassword } from "firebase/auth"
import {useNavigate} from "react-router-dom"

const New = ({ inputs, title }) => {
  const [file, setFile] = useState("");
  const [data, setData] = useState({})
  const navigate = useNavigate()

  const handleInput = (e) => {
    const id = e.target.id;
    const value = e.target.value

    setData({...data, [id]: value});
  }

  console.log(data)

  const handleAdd = async (e) =>{
    e.preventDefault()
    try{
      // const res = await createUserWithEmailAndPassword(
      //   auth,
      //   data.email,
      //   data.password
      // )
       const res = await addDoc(collection(db, "users"), {
      username:data.username,
      email:data.email,
      address:data.address,
      phonenumber:data.phonenumber,
      password:data.password,
      timeStamp: serverTimestamp()
    });
    console.log(res)
    navigate(-1)
    }catch(err){
      console.log(err)
    }
      
  }
    
    
  

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          {/* <div className="left">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt=""
            />
          </div> */}
          <div className="right">
            <form onSubmit={handleAdd}>
              

              {inputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    id={input.id}
                    type={input.type}
                    placeholder={input.placeholder}
                    required
                    onChange = {handleInput} />
                </div>
              ))}
              <button type = "submit">Add</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
